'use client'
import { memo } from 'react'
import { useRouter } from 'next/navigation'
import styled from 'styled-components'
import { mq, vw } from '../../styles'
import { useScrollTracker } from '../../hooks'

const Button = styled.button<{ $sticky: boolean,  $scrollTop: boolean }>`
  align-items: center;
  background-color: #262626;
  border-radius: ${({ $sticky }) => $sticky ? 0 : '50%'};
  display: flex;
  height: ${vw(50, 'mobile')};
  justify-content: center;
  left: ${vw(20, 'mobile')};
  position: fixed;
  top: 82px;
  transition: 200ms all ease;
  width: ${vw(50, 'mobile')};
  z-index: 20;

  ${mq.greaterThan('tablet')} {
    height: ${vw(80, 'desktop')};
    left: ${({ $sticky }) => $sticky ? 0 : `${vw(20, 'desktop')}`};
    top: ${({ $sticky, $scrollTop }) => $sticky ? '80px' : `${$scrollTop ? '120px' : '92px'}`};
    width: ${({ $sticky }) => vw($sticky ? 120 : 80, 'desktop')};
  }


  ${mq.greaterThan('desktop')} {
    height: 80px;
    left: ${({ $sticky }) => $sticky ? 0 : '20px'};
    top: ${({ $sticky, $scrollTop }) => $sticky ? '80px' : `${$scrollTop ? '120px' : '92px'}`};
    width: ${({ $sticky }) => $sticky ? 120 : 80}px;
  }


  img {
    transform: rotate(90deg);
    width: ${vw(8, 'mobile')};

    ${mq.greaterThan('tablet')} {
      width: ${vw(18, 'desktop')};
    }

    ${ mq.greaterThan('desktop') } {
      width: 18px;
    }
  }
`

interface IButtonBack {
  sticky?: boolean,
  category?: any
}

export const ButtonBack = memo(({ sticky = false }:IButtonBack) => {
  const { scrollOnTop } = useScrollTracker(2)
  const router = useRouter() || { back: () => {} }

  const onClick = () => {
    router.back()
  }

  return (
    <Button $sticky={sticky} $scrollTop={scrollOnTop} onClick={onClick} title='Ir atrás'>
      <img src='/images/svg/i--chevron--white.svg' alt='Icon arrow back' width='16' height='16'/>
    </Button>
  )
})
